import resolve from '../resolve-url';

export default {
	methods: {
		resolveUrl(url) {
			return resolve(url, this.$store.state.header.baseUrl);
		}
	}
};
